const general = {
  PACKAGE_NAME: 'DigitalVideoWebNodeStorefront',
  STATUS_OK: 200,
  SEARCH_ASIN_TYPE: 'StorefrontSearchAsin',
  SEARCH_ASIN_METRIC_ENDPOINT: '/gp/video/ajax/storefront-analytics.html',
  ENRICH_API_ENDPOINT: '/gp/video/api/storefrontEnrichItems',
  ENRICH_THROTTLE_LIMIT: 200,
  liveChannelsRefresh: {
    LIVECHANNELS_UPDATE_API_ENDPOINT: '/gp/video/api/liveChannelUpdate',
    additionalParams: 'use16x9Packshot=true&getMetadataFromCSS=true',
    REFRESH_INTERVAL: 60000
  }
}

const widgetNames = {
  STOREFRONT: 'Storefront'
}

export {
  general as default,
  widgetNames
}
